module.exports = __webpack_public_path__ + "static/media/everyone-is-doing-well.887cc68f.svg";